<div class="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-5 tw-py-4 tw-flex tw-flex-col tw-gap-4">
  <div class="tw-flex tw-flex-col tw-gap-1">
    <h2 class="tw-text-gray-900 tw-text-sm lg:tw-text-base tw-font-bold tw-font-inter">Persona configuration</h2>
    <p class="tw-text-gray-500 tw-text-sm tw-font-normal tw-font-inter">
      Choose which personas can use the self-print link and optionally cap how many badges each can print. Leave the limit empty or set it to 0 for no cap.
    </p>
  </div>

  @if (personas().length === 0) {
    <p class="tw-text-sm tw-text-gray-500 tw-font-inter">No personas found for this event.</p>
  } @else {
    <div class="tw-flex tw-flex-col tw-gap-2">
      @for (persona of personas(); track persona.id) {
        <div
          class="tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50 tw-px-4 tw-py-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between"
          [ngClass]="{
            'tw-opacity-50': !persona.enabled
          }"
        >
          <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-3 sm:tw-flex-1">
            <label class="tw-inline-flex tw-shrink-0 tw-cursor-pointer">
              <input
                type="checkbox"
                class="tw-sr-only tw-peer"
                [checked]="persona.enabled"
                (change)="onSelfPrintToggle(persona.id, $event)"
              />
              <div
                class="tw-relative tw-w-11 tw-h-6 tw-bg-gray-200 peer-focus:tw-outline-none peer-focus:tw-ring-4 peer-focus:tw-ring-blue-300 dark:peer-focus:tw-ring-blue-800 tw-rounded-full tw-peer dark:tw-bg-gray-700 peer-checked:after:tw-translate-x-full rtl:peer-checked:after:-tw-translate-x-full peer-checked:after:tw-border-white after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-start-[2px] after:tw-bg-white after:tw-border-gray-300 after:tw-border after:tw-rounded-full after:tw-w-5 after:tw-h-5 after:tw-transition-all dark:tw-border-gray-600 peer-checked:tw-bg-blue-600 dark:peer-checked:tw-bg-blue-600"
              ></div>
            </label>
            <span class="tw-min-w-0 tw-break-words tw-text-sm tw-font-semibold tw-text-gray-900 tw-font-inter">{{ persona.name }}</span>
          </div>

          <div class="tw-flex tw-w-full tw-flex-col tw-gap-1 sm:tw-w-auto sm:tw-min-w-[200px] lg:tw-min-w-0">
            <div class="tw-flex tw-w-full tw-flex-row tw-items-center tw-gap-2 sm:tw-min-w-[200px] lg:tw-min-w-0">
              <label
                class="tw-shrink-0 tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-gray-600 tw-font-inter"
                [attr.for]="'self-print-limit-' + persona.id"
              >
                Max print limit
              </label>
              <input
                type="number"
                [id]="'self-print-limit-' + persona.id"
                [formControl]="persona.limitControl"
                [disabled]="!persona.enabled"
                min="0"
                step="1"
                (keydown)="onLimitKeydown($event)"
                (paste)="onLimitPaste($event, persona)"
                (wheel)="onLimitWheel($event)"
                (input)="onLimitInput()"
                [placeholder]="'No limit'"
                autocomplete="off"
                inputmode="numeric"
                class="tw-min-w-0 tw-flex-1 tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-gray-900 tw-font-inter tw-placeholder:text-gray-400 focus:tw-border-blue-500 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500/20 disabled:tw-cursor-not-allowed disabled:tw-bg-gray-100 disabled:tw-opacity-70 lg:tw-flex-none lg:tw-w-28"
                [ngClass]="{
                  'tw-border-red-500': persona.limitControl.invalid && (persona.limitControl.dirty || persona.limitControl.touched)
                }"
              />
            </div>
            @if (persona.enabled && persona.limitControl.invalid && (persona.limitControl.dirty || persona.limitControl.touched)) {
              <span class="tw-text-xs tw-text-red-600 tw-font-inter">Enter a non-negative whole number or leave empty for no cap.</span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
